import React from 'react';
import { View } from 'react-native';
import { useTheme } from '../contexts/ThemeContext';

const GradientBackground = ({ children, style }) => {
  const { theme } = useTheme();

  // Usar View simples com a cor de fundo do tema (claro ou escuro)
  return (
    <View style={[{ flex: 1, backgroundColor: theme.colors.background }, style]}>
      {children}
    </View>
  );
};

export default GradientBackground;

